/* Standish Milling redesigned site: product page, cart page, filters, related products, login.
   Loaded with `defer` on every template except the home page (which only needs smc-home.js).
   Plain JS, no libraries. */
(function () {
  'use strict';

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function money(cents, currency) {
    var v = (cents || 0) / 100;
    try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency || 'USD' }).format(v); }
    catch (e) { return '$' + v.toFixed(2); }
  }

  /* -------------------------------------------------------- shipping estimator */
  var SHIP_ZIP_KEY = 'smc-ship-zip';
  var FREIGHT_GRAMS = 18144; // 40 lb in grams: at or above this a variant ships by freight
  var PICKUP_RATE = /pick\s*-?\s*up/i;
  var SHIP_ADD_FIRST = 'Add this item to your cart, then get rates to your ZIP. Rates cover everything in your cart.';
  var SHIP_FALLBACK = 'Could not get rates. Call (989) 846-6880 for a freight quote.';
  var RATE_PRICE = /^\s*\d+(\.\d+)?\s*$/;

  /* Cents for a rate we can quote, or null. Only a rate object whose price is a finite number >= 0, or a plain
     numeric string such as "12.34" or "0.00", counts; a missing, null or non-numeric price (or a null rate) is
     dropped, so a broken carrier reply never reads as free shipping (PR #22 gate). */
  function rateCents(rate) {
    if (!rate || typeof rate !== 'object') return null;
    var p = rate.price;
    if (typeof p === 'string' && RATE_PRICE.test(p)) p = parseFloat(p);
    if (typeof p !== 'number' || !isFinite(p) || p < 0) return null;
    return Math.round(p * 100);
  }
  var SHIP_TIMEOUT_MS = 20000; // whole estimate cycle: cart gate, prepare and polling
  var US_STATES = {
    Alabama: 'AL', Alaska: 'AK', Arizona: 'AZ', Arkansas: 'AR', California: 'CA', Colorado: 'CO',
    Connecticut: 'CT', Delaware: 'DE', Florida: 'FL', Georgia: 'GA', Hawaii: 'HI', Idaho: 'ID',
    Illinois: 'IL', Indiana: 'IN', Iowa: 'IA', Kansas: 'KS', Kentucky: 'KY', Louisiana: 'LA',
    Maine: 'ME', Maryland: 'MD', Massachusetts: 'MA', Michigan: 'MI', Minnesota: 'MN', Mississippi: 'MS',
    Missouri: 'MO', Montana: 'MT', Nebraska: 'NE', Nevada: 'NV', 'New Hampshire': 'NH', 'New Jersey': 'NJ',
    'New Mexico': 'NM', 'New York': 'NY', 'North Carolina': 'NC', 'North Dakota': 'ND', Ohio: 'OH',
    Oklahoma: 'OK', Oregon: 'OR', Pennsylvania: 'PA', 'Rhode Island': 'RI', 'South Carolina': 'SC',
    'South Dakota': 'SD', Tennessee: 'TN', Texas: 'TX', Utah: 'UT', Vermont: 'VT', Virginia: 'VA',
    Washington: 'WA', 'West Virginia': 'WV', Wisconsin: 'WI', Wyoming: 'WY',
    'District of Columbia': 'DC', 'Puerto Rico': 'PR'
  };

  function provinceLabel(name) {
    if (!name) return '';
    return US_STATES[name] || name;
  }

  /* Shopify answers 422 with {"errors":{"zip":["is not valid"]}}, a plain string errors value,
     {"message": "..."} or a top-level field map. Flatten whatever arrives into one sentence. */
  function shipErrorText(data) {
    var parts = [];
    function add(v) {
      if (v === null || v === undefined) return;
      if (typeof v === 'string') { if (v.trim()) parts.push(v.trim()); return; }
      if (Array.isArray(v)) { v.forEach(add); return; }
      Object.keys(v).forEach(function (k) { add(v[k]); });
    }
    if (data && typeof data === 'object') {
      if (data.errors) add(data.errors);
      else if (data.message) add(data.message);
      else Object.keys(data).forEach(function (k) { if (k !== 'status') add(data[k]); });
    }
    return parts.join(' ');
  }

  function getJson(r) {
    return r.text().then(function (text) {
      var data = null;
      if (text) { try { data = JSON.parse(text); } catch (e) { data = null; } }
      if (!r.ok) { var err = new Error('HTTP ' + r.status); err.status = r.status; err.data = data; throw err; }
      return data;
    });
  }

  /* One estimator per [data-smc-ship-estimate] wrapper. Rates quote the cart exactly as it is:
     the estimator only ever reads the cart, it never adds or changes anything. `opts.product`
     marks the copy on the product page, where a rate request is gated on the selected variant
     already being in the cart. Idempotent: returns the existing instance if there is one. */
  function initShipEstimate(el, opts) {
    if (!el) return null;
    if (el._smcShip) return el._smcShip;
    var country = $('[data-smc-ship-country]', el);
    var province = $('[data-smc-ship-province]', el);
    var zip = $('[data-smc-ship-zip]', el);
    var go = $('[data-smc-ship-go]', el);
    var result = $('[data-smc-ship-result]', el);
    if (!country || !province || !zip || !go || !result) return null;
    opts = opts || {};
    var productMode = !!opts.product;
    var variantId = opts.variantId || el.getAttribute('data-variant-id') || null;
    var currency = el.getAttribute('data-money') || 'USD';
    var token = 0; // bumping this drops every callback from an older request
    var deadline = null; // overall-timeout timer for the request in flight
    var ctrl = null; // aborts that request's stalled fetches when the deadline hits

    function clearResult() { while (result.firstChild) result.removeChild(result.firstChild); }
    function say(text) {
      clearResult();
      result.appendChild(document.createTextNode(text));
    }
    function signal() { return ctrl ? ctrl.signal : undefined; }
    function disarm() { // stop the clock and abort whatever is still in flight
      if (deadline) { clearTimeout(deadline); deadline = null; }
      if (ctrl) { var c = ctrl; ctrl = null; try { c.abort(); } catch (e) { /* already settled */ } }
    }
    function finish() { // every terminal path hands the button back and stops the clock
      disarm();
      go.disabled = false;
    }
    function arm(my) {
      disarm();
      ctrl = typeof AbortController !== 'undefined' ? new AbortController() : null;
      deadline = setTimeout(function () {
        if (my !== token || !el.isConnected) { disarm(); return; }
        token++; // this request is over: drop its pending callbacks
        finish();
        fail();
      }, SHIP_TIMEOUT_MS);
    }
    function invalidate() {
      token++;
      disarm();
      go.disabled = false;
      clearResult();
    }
    function loadZip() {
      try {
        var saved = window.localStorage.getItem(SHIP_ZIP_KEY);
        if (saved) zip.value = saved;
      } catch (e) { /* private mode: no stored ZIP, no prefill */ }
    }
    function saveZip() {
      try { window.localStorage.setItem(SHIP_ZIP_KEY, zip.value || ''); } catch (e) { /* storage full or blocked */ }
    }

    function fillProvinces() {
      var opt = country.options[country.selectedIndex];
      var raw = opt ? opt.getAttribute('data-provinces') : '';
      var list = [];
      if (raw) { try { list = JSON.parse(raw); } catch (e) { list = []; } }
      province.textContent = '';
      if (!Array.isArray(list) || !list.length) { province.disabled = true; return; }
      province.disabled = false;
      var blank = document.createElement('option');
      blank.value = '';
      blank.textContent = 'State';
      province.appendChild(blank);
      list.forEach(function (p) {
        var name = typeof p === 'string' ? p : (p && (p[0] || p.name)) || '';
        if (!name) return;
        var o = document.createElement('option');
        o.value = name;
        o.textContent = name;
        province.appendChild(o);
      });
    }

    function defaultCountry() {
      var options = Array.prototype.slice.call(country.options);
      var us = options.filter(function (o) { return o.value === 'United States'; })[0];
      if (us) country.value = us.value; // the country_option_tags option carries data-provinces
      else if (options.length) country.selectedIndex = 0;
    }

    function addressQuery() {
      return 'shipping_address[zip]=' + encodeURIComponent(zip.value.trim()) +
        '&shipping_address[country]=' + encodeURIComponent(country.value) +
        '&shipping_address[province]=' + encodeURIComponent(province.value || '');
    }

    function fail() { say(SHIP_FALLBACK); }

    function invalid(data) {
      var detail = shipErrorText(data);
      say(detail ? 'We could not get rates for that address: ' + detail : 'We could not get rates for that address.');
    }

    /* The pickup note follows whatever else the result says: after a rate list, and after the
       freight-quote fallback when the wrapper says the cart can be picked up. */
    function appendPickup(shown) {
      if (!shown && el.getAttribute('data-smc-pickup') !== '1') return;
      var note = document.createElement('p');
      note.className = 'smc-ship__pickup';
      note.textContent = 'Free local pickup at our Standish mill';
      result.appendChild(note);
    }

    function noRates() { // no carrier came back: still worth saying the mill is an option
      finish();
      clearResult();
      result.appendChild(document.createTextNode(SHIP_FALLBACK));
      appendPickup(false);
    }

    function showRates(z, prov, rates) {
      clearResult();
      var label = provinceLabel(prov);
      var head = document.createElement('p');
      head.className = 'smc-ship__dest';
      head.textContent = 'Rates to ' + z + (label ? ', ' + label : '');
      result.appendChild(head);
      var list = document.createElement('ul');
      list.className = 'smc-ship__rates';
      rates.forEach(function (rate) {
        var li = document.createElement('li');
        var name = document.createElement('span');
        name.className = 'smc-ship__name';
        name.textContent = rate && rate.name ? rate.name : 'Shipping';
        var price = document.createElement('span');
        price.className = 'smc-ship__price';
        var cents = rateCents(rate);
        price.textContent = cents === 0 ? 'Free' : money(cents, currency);
        li.appendChild(name);
        li.appendChild(price);
        list.appendChild(li);
      });
      result.appendChild(list);
      appendPickup(rates.some(function (rate) { return PICKUP_RATE.test((rate && rate.name) || ''); }));
    }

    function poll(query, attempt, my) {
      if (my !== token) return; // a newer request (or an edit) owns the box now
      if (attempt >= 20) { finish(); fail(); return; }
      fetch('/cart/async_shipping_rates.json?' + query, { headers: { Accept: 'application/json' }, signal: signal() })
        .then(getJson)
        .then(function (data) {
          if (my !== token || !el.isConnected) return;
          if (data === null || data === undefined) { // Shopify is still calculating
            setTimeout(function () { poll(query, attempt + 1, my); }, 500);
            return;
          }
          var rates = data && data.shipping_rates;
          rates = Array.isArray(rates) ? rates.filter(function (rate) { return rateCents(rate) !== null; }) : [];
          if (!rates.length) { noRates(); return; }
          finish();
          showRates(zip.value.trim(), province.value, rates);
        })
        .catch(function (err) {
          if (my !== token) return;
          finish();
          if (err && err.status === 422) invalid(err.data);
          else fail();
        });
    }

    function estimate() {
      var my = ++token;
      saveZip();
      if (productMode && !variantId) { say(SHIP_ADD_FIRST); return; } // no current variant: nothing to quote
      say('Getting rates...'); // from here on, gates included, no stale quote stays on screen
      go.disabled = true;
      arm(my); // bounded even if a fetch never answers
      var query = addressQuery();
      var start = function () {
        fetch('/cart/prepare_shipping_rates.json', {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded', Accept: 'application/json' },
          body: query,
          signal: signal()
        })
          .then(getJson)
          .then(function () {
            if (my !== token || !el.isConnected) return;
            poll(query, 0, my);
          })
          .catch(function (err) {
            if (my !== token) return;
            finish();
            if (err && err.status === 422) invalid(err.data);
            else fail();
          });
      };
      if (!productMode) { start(); return; }
      // Rates cover the whole cart, so only quote once this variant is actually in it.
      fetch('/cart.js', { headers: { Accept: 'application/json' }, signal: signal() })
        .then(getJson)
        .then(function (cart) {
          if (my !== token || !el.isConnected) return;
          var inCart = !!(cart && cart.items && cart.items.some(function (it) {
            return String(it.variant_id) === String(variantId);
          }));
          if (!inCart) { finish(); say(SHIP_ADD_FIRST); return; }
          start();
        })
        .catch(function () {
          if (my !== token) return;
          finish();
          fail();
        });
    }

    zip.addEventListener('input', function () { saveZip(); invalidate(); });
    country.addEventListener('change', function () { fillProvinces(); invalidate(); });
    province.addEventListener('change', invalidate);
    zip.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); estimate(); } // never submits the parent cart form
    });
    go.addEventListener('click', estimate);

    defaultCountry();
    fillProvinces();
    loadZip();

    el._smcShip = {
      setVariant: function (id) {
        if (!productMode) return;
        var next = id || null;
        if (String(next) === String(variantId)) return;
        variantId = next;
        if (next) el.setAttribute('data-variant-id', String(next));
        else el.removeAttribute('data-variant-id');
        invalidate(); // a pending quote was for another variant: drop it
      }
    };
    return el._smcShip;
  }

  /* ------------------------------------------------------------ product page */
  function initProduct(root) {
    var form = $('[data-smc-pdp-form]', root);
    var json = $('[data-smc-variants]', root);
    if (!form || !json) return;
    var variants;
    try { variants = JSON.parse(json.textContent); } catch (e) { return; }
    var currency = root.getAttribute('data-money') || 'USD';
    var idInput = $('[data-smc-variant-id]', form);
    var qty = $('[data-smc-qty]', form);
    var submit = $('[data-smc-submit]', form);
    var submitLabel = $('[data-smc-submit-label]', form);
    var priceNow = $('[data-smc-price-now]', root);
    var priceWas = $('[data-smc-price-was]', root);
    var stock = $('[data-smc-stock]', root);
    var skuEl = $('[data-smc-sku]', root);
    var fieldsets = $$('[data-smc-option]', form);
    var current = null;
    var volume = [];
    var freightNote = $('[data-smc-freight]', root);
    var estimators = [];

    function selectedValues() {
      return fieldsets.map(function (fs) {
        var c = $('input:checked', fs);
        return c ? c.value : null;
      });
    }

    function findVariant() {
      var sel = selectedValues();
      if (!fieldsets.length) return variants[0];
      return variants.filter(function (v) {
        return sel.every(function (val, i) { return v['option' + (i + 1)] === val; });
      })[0] || null;
    }

    function showMedia(id) {
      var slide = $('.smc-gallery__slide[data-media-id="' + id + '"]', root);
      if (!slide) return;
      $$('.smc-gallery__slide', root).forEach(function (s) { s.hidden = s !== slide; });
      $$('.smc-thumb', root).forEach(function (t) {
        var on = t.getAttribute('data-media-target') === String(id);
        t.classList.toggle('is-on', on);
        t.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    /* Keeps every estimator on this page (including the hidden #smc-ship one) in step with the
       selection: rates are only quoted for the variant actually shown, and a pending quote for a
       different variant is dropped. */
    function syncShip(variantId) {
      estimators.forEach(function (api) { if (api) api.setVariant(variantId); });
    }

    function update(fromUser) {
      var v = findVariant();
      current = v;
      fieldsets.forEach(function (fs) {
        var c = $('input:checked', fs), l = $('[data-smc-option-label]', fs);
        if (c && l) l.textContent = c.value;
      });
      syncShip(v ? v.id : null);
      if (freightNote && !freightNote.hasAttribute('data-smc-freight-tag')) freightNote.hidden = !(v && v.weight >= FREIGHT_GRAMS);
      if (!v) {
        submit.disabled = true;
        submitLabel.textContent = 'Unavailable';
        stock.textContent = 'This combination is not available';
        idInput.value = ''; // never leave a stale variant id in the form
        return;
      }
      idInput.value = v.id;
      idInput.dispatchEvent(new Event('change', { bubbles: true })); // keeps the accelerated checkout button in step
      priceNow.textContent = money(v.price, currency);
      if (v.compare_at_price && v.compare_at_price > v.price) { priceWas.hidden = false; priceWas.textContent = money(v.compare_at_price, currency); }
      else priceWas.hidden = true;
      submit.disabled = !v.available;
      submitLabel.textContent = v.available ? 'Add to cart' : 'Sold out';
      stock.innerHTML = '<span class="smc-dot ' + (v.available ? 'smc-dot--in' : 'smc-dot--out') + '"></span>' + (v.available ? 'In stock' : 'Sold out');
      if (skuEl) skuEl.textContent = v.sku || '';
      if (v.featured_media && v.featured_media.id) showMedia(v.featured_media.id);
      if (fromUser && window.history && history.replaceState) {
        var u = new URL(window.location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u.toString());
      }
      volumeUpdate();
    }

    form.addEventListener('change', function (e) {
      if (e.target && e.target.type === 'radio') update(true);
    });

    // Quantity stepper
    $$('[data-smc-qty-step]', form).forEach(function (b) {
      b.addEventListener('click', function () {
        var n = parseInt(qty.value, 10) || 1;
        n = Math.max(1, n + parseInt(b.getAttribute('data-smc-qty-step'), 10));
        qty.value = n;
        volumeUpdate();
      });
    });
    qty.addEventListener('input', volumeUpdate);

    // Gallery thumbnails
    $$('.smc-thumb', root).forEach(function (t) {
      t.addEventListener('click', function () { showMedia(t.getAttribute('data-media-target')); });
    });

    /* Volume discounts. The Yanet app prints its tier table (qty -> % off) on the page and applies the
       discount at checkout; this only previews it: "Buy N more to get X% off" and a discounted total. */
    var hint = $('[data-smc-volume-hint]', root);
    var total = $('[data-smc-total]', root);
    function readTiers() {
      var rows = $$('.yn-dc-promo-table-body tr');
      var tiers = [];
      rows.forEach(function (tr) {
        var tds = tr.querySelectorAll('td');
        if (tds.length < 2) return;
        var q = parseFloat((tds[0].textContent.match(/(\d+(\.\d+)?)/) || [])[1]);
        var p = parseFloat((tds[1].textContent.match(/(\d+(\.\d+)?)/) || [])[1]);
        if (!isNaN(q) && !isNaN(p)) tiers.push([q, p]);
      });
      tiers.sort(function (a, b) { return a[0] - b[0]; });
      return tiers;
    }
    function volumeUpdate() {
      if (!hint || !total) return;
      if (!volume.length) volume = readTiers();
      var v = current || variants[0];
      var n = parseInt(qty.value, 10) || 1;
      if (!volume.length || !v) { hint.hidden = true; total.hidden = true; return; }
      var pct = 0, next = null;
      volume.forEach(function (t) { if (n >= t[0]) pct = t[1]; else if (!next) next = t; });
      if (next) { hint.hidden = false; hint.textContent = 'Buy ' + (next[0] - n) + ' more to get ' + next[1] + '% off.'; }
      else hint.hidden = true;
      if (n > 1 || pct) {
        var base = v.price * n, final = base * (1 - pct / 100);
        total.hidden = false;
        total.textContent = pct ? 'Total for ' + n + ': ' + money(final, currency) + ' (' + pct + '% off applied at checkout)' : 'Total for ' + n + ': ' + money(base, currency);
      } else total.hidden = true;
    }
    // the app renders its table after load; look for it for a few seconds
    var tries = 0;
    var poll = setInterval(function () {
      tries++;
      if (!volume.length) { volume = readTiers(); if (volume.length) volumeUpdate(); }
      if (volume.length || tries > 15) clearInterval(poll);
    }, 500);

    current = findVariant();
    volumeUpdate();

    // Freight reveal: unhide the estimator, then focus the ZIP field. No auto-quote, no form submit.
    $$('[data-smc-ship-open]', root).forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        var wrap = document.getElementById('smc-ship');
        if (!wrap) return;
        wrap.hidden = false;
        link.setAttribute('aria-expanded', 'true');
        var z = $('[data-smc-ship-zip]', wrap);
        if (z) z.focus();
      });
    });

    estimators = $$('[data-smc-ship-estimate]', root).map(function (node) {
      return initShipEstimate(node, { product: true, variantId: current && current.id });
    });
  }

  /* --------------------------------------------------------------- cart page */
  function initCart() {
    var root = $('[data-smc-cart]');
    if (!root) return;
    var busy = false;

    function refresh() {
      return fetch(window.location.pathname, { headers: { Accept: 'text/html' } })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-smc-cart]');
          if (fresh) {
            root.innerHTML = fresh.innerHTML;
            // The estimator markup was just replaced: start it again on the new nodes.
            $$('[data-smc-ship-estimate]', root).forEach(function (node) { initShipEstimate(node); });
          }
          return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
        })
        .then(function (cart) { if (window.smcUpdateCart) window.smcUpdateCart(cart); });
    }

    function change(line, quantity) {
      if (busy) return;
      busy = true;
      root.classList.add('is-busy');
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not update the cart'); return j; }); })
        .then(refresh)
        .catch(function (err) {
          var m = $('[data-smc-cart-msg]', root);
          if (m) { m.hidden = false; m.textContent = err.message; }
          return refresh();
        })
        .then(function () { busy = false; root.classList.remove('is-busy'); });
    }

    var timers = {};
    root.addEventListener('click', function (e) {
      var step = e.target.closest && e.target.closest('[data-smc-step]');
      var rem = e.target.closest && e.target.closest('[data-smc-remove]');
      if (step) {
        var li = step.closest('.smc-line'), input = $('[data-smc-line-qty]', li);
        var n = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(step.getAttribute('data-smc-step'), 10));
        input.value = n;
        var line = parseInt(li.getAttribute('data-line'), 10);
        clearTimeout(timers[line]);
        timers[line] = setTimeout(function () { change(line, n); }, 450);
      } else if (rem) {
        e.preventDefault();
        change(parseInt(rem.closest('.smc-line').getAttribute('data-line'), 10), 0);
      }
    });
    root.addEventListener('change', function (e) {
      var input = e.target.closest && e.target.closest('[data-smc-line-qty]');
      if (!input) return;
      change(parseInt(input.closest('.smc-line').getAttribute('data-line'), 10), Math.max(0, parseInt(input.value, 10) || 0));
    });
  }

  /* ----------------------------------------------------------------- filters */
  function initFilters(form) {
    var timer;
    function submit() { clearTimeout(timer); timer = setTimeout(function () { form.submit(); }, 250); }
    form.addEventListener('change', function (e) { if (e.target.closest('[data-smc-filters]')) submit(); });
    var drops = $$('.smc-fdrop', form);
    drops.forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (d.open) drops.forEach(function (o) { if (o !== d) o.open = false; });
      });
    });
    document.addEventListener('click', function (e) {
      if (!form.contains(e.target)) drops.forEach(function (d) { d.open = false; });
    });
    form.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') drops.forEach(function (d) { d.open = false; });
    });
  }

  /* ----------------------------------------------------------------- related */
  function initRelated(root) {
    if (!root.hasAttribute('hidden') && root.children.length) return;
    var url = root.getAttribute('data-url');
    if (!url || !window.fetch) return;
    fetch(url).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-smc-related]');
      if (fresh && fresh.children.length) { root.innerHTML = fresh.innerHTML; root.hidden = false; }
    }).catch(function () {});
  }

  /* ------------------------------------------------------------------- login */
  function initLogin() {
    var login = $('#CustomerLoginForm'), recover = $('#RecoverPasswordForm');
    if (!login || !recover) return;
    function show(r) { recover.style.display = r ? '' : 'none'; login.style.display = r ? 'none' : ''; }
    var open = $('#RecoverPassword'), close = $('#HideRecoverPasswordLink');
    if (open) open.addEventListener('click', function (e) { e.preventDefault(); show(true); });
    if (close) close.addEventListener('click', function (e) { e.preventDefault(); show(false); });
    if (window.location.hash === '#recover') show(true);
    if ($('[data-smc-reset-posted]')) { var ok = $('#ResetSuccess'); if (ok) ok.style.display = ''; }
  }

  function boot() {
    $$('[data-smc-product]').forEach(initProduct);
    $$('[data-smc-filters]').forEach(initFilters);
    $$('[data-smc-related]').forEach(initRelated);
    initCart();
    initLogin();
    $$('[data-smc-ship-estimate]').forEach(function (el) { initShipEstimate(el); }); // cart copy; product copy is up already
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
